import { type FC, type PropsWithChildren } from 'react'

import { Link } from 'base-ui'

type TextLinkProps = PropsWithChildren<{
  href: string
}>

export const ContactPageFaqCardsSectionCardTextLink: FC<TextLinkProps> = ({
  children,
  href,
}) => (
  <Link className="relative z-10" color="inherit" href={href}>
    {children}
  </Link>
)
